/* eslint-disable prettier/prettier */
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import InventoryIcon from '@mui/icons-material/Inventory2';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SettingsIcon from '@mui/icons-material/Settings';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CategoryIcon from '@mui/icons-material/Category';
import FiberManualRecordTwoToneIcon from '@mui/icons-material/FiberManualRecordTwoTone';

const GROUP_ICON_MAP = {
  accounts: AccountBalanceIcon,
  purchase: ShoppingCartIcon,
  sales: PointOfSaleIcon,
  master: SettingsIcon,
  reception: StorefrontIcon,
  production: PrecisionManufacturingIcon,
  'work process': InventoryIcon,
  'stock reports': DescriptionIcon,
  reports: AssessmentIcon,
  'tally exports': ImportExportIcon,
  'gst reports': ReceiptLongIcon,
  default: CategoryIcon
};

export default function SidebarMenu() {
  const functions = JSON.parse(localStorage.getItem('functionsData') || '[]');

  const grouped = functions.reduce((acc, fn) => {
    const category = fn.category?.toLowerCase() || 'others';
    acc[category] = acc[category] || [];
    acc[category].push(fn);
    return acc;
  }, {});

  const menuGroups = [];

  Object.entries(grouped).forEach(([category, items]) => {
    const categoryKey = category.replace(/\s+/g, '-');
   const categoryTitle = items[0]?.category || category;

    if (items.length === 1) {
      const fn = items[0];
      const Icon = GROUP_ICON_MAP[category] || GROUP_ICON_MAP.default;

      menuGroups.push({
        id: categoryKey,
        type: 'group',
        children: [
          {
            id: fn.id.toString(),
            title: fn.functionality,
            type: 'item',
            url: fn.launch,
            icon: Icon,
            breadcrumbs: false
          }
        ]
      });

      return;
    }

    const GroupIcon = GROUP_ICON_MAP[category] || GROUP_ICON_MAP.default;

    menuGroups.push({
      id: categoryKey,
      title: categoryTitle,
      type: 'group',
      children: [
        {
          id: `${categoryKey}-collapse`,
          title: categoryTitle,
          type: 'collapse',
          icon: GroupIcon,
          children: items.map((fn) => ({
            id: fn.id.toString(),
            title: fn.functionality,
            type: 'item',
            url: fn.launch,
            icon: FiberManualRecordTwoToneIcon,
            breadcrumbs: false
          }))
        }
      ]
    });
  });

  return menuGroups;
}
